var pad = require('./pad');

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/node_modules/underscore.string/lpad.js
// module id = ../../../../underscore.string/lpad.js
// module chunks = polyfills